var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FeatureFlag } from "healthex-common/features.dtos";
import { slugifyOptional, unslugifyOptional } from "healthex-common/utils";
import { action, computed } from "mobx";
import { HXMenuController } from "./HXMenu";
import { NamedRoutes } from "./NamedRoutes";
export var PatientRecordsSection;
(function (PatientRecordsSection) {
    PatientRecordsSection["TIMELINE"] = "TIMELINE";
    PatientRecordsSection["SOURCES"] = "SOURCES";
})(PatientRecordsSection || (PatientRecordsSection = {}));
export function parsePatientRecordsSection(slug) {
    const section = unslugifyOptional(slug);
    if (section && Object.values(PatientRecordsSection).includes(section))
        return section;
    return PatientRecordsSection.TIMELINE;
}
export class PatientRecordsViewModel {
    constructor(container) {
        this.moreMenuController = new HXMenuController();
        this.featureManager = container.featureManager;
        this.routingUIManager = container.routingUIManager;
    }
    get isHealthWalletEnabled() {
        if (!this.featureManager.hasLoadedFeatures)
            return false;
        return this.featureManager.isFeatureEnabled(FeatureFlag.RO_HEALTH_WALLET_ENABLED);
    }
    get isSourcesTabEnabled() {
        if (!this.featureManager.hasLoadedFeatures)
            return false;
        return this.featureManager.isFeatureEnabled(FeatureFlag.RO_HEALTH_WALLET_SOURCES_ENABLED);
    }
    get currentSection() {
        var _a;
        return parsePatientRecordsSection((_a = this.routingUIManager.currentRouteParams) === null || _a === void 0 ? void 0 : _a.section);
    }
    setSection(section) {
        this.routingUIManager.navigateTo(NamedRoutes.PATIENT_RECORDS, {
            section: slugifyOptional(section),
        });
    }
}
__decorate([
    computed
], PatientRecordsViewModel.prototype, "isHealthWalletEnabled", null);
__decorate([
    computed
], PatientRecordsViewModel.prototype, "isSourcesTabEnabled", null);
__decorate([
    computed
], PatientRecordsViewModel.prototype, "currentSection", null);
__decorate([
    action
], PatientRecordsViewModel.prototype, "setSection", null);
